import { StateCreator } from "@/store/utils"

export interface AppState {
  version?: string
}

export interface AppSlice {
  app: AppState & {
    actions: {
      setVersion(version: string): void
    }
  }
}

export function initialState(): AppState {
  return {}
}

function actionName(name: string) {
  return `app/${name}`
}

const createAppSlice: StateCreator<AppSlice> = (set) => ({
  app: {
    ...initialState(),
    actions: {
      setVersion(version) {
        set(
          (state) => {
            state.app.version = version

            return state
          },
          undefined,
          actionName("setVersion")
        )
      },
    },
  },
})

export default createAppSlice
